import { render, staticRenderFns } from "./MyTestsPage.vue?vue&type=template&id=5ff3468f&"
import script from "./MyTestsPage.vue?vue&type=script&lang=js&"
export * from "./MyTestsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports